import * as React from "react";

import "./mobile-view-card.scss";

import {formatDate} from "@Common/ui-components/format-date";

import {ImageGallery} from "../common/image-gallery/image-gallery";

import {formatFlexMoney} from "./format-flex-money";

export const MobileViewCard = ({record, onCreateMarketingMaterials}) => (
    <div className="mobile-view-card-cj9">
        <div className="image-section">
            <div className="address">
                <span xd-qa-type="label" xd-qa-name={record.mlsId+" - Address"}>
                    {record.streetAddress}
                    <br/>
                    {record.city}, {record.state} {record.zip}
                </span>
                <div className="mls-id">
                    <label>ID:</label>
                    <span xd-qa-type="label" xd-qa-name={record.mlsId+" - ID"}>{record.mlsId}</span>
                </div>
            </div>

            <ImageGallery {...{pictures: record.thumbPictures}}/>
        </div>
        <div className="horizontal-divider"/>
        <div className="info">
            <div className="col">
                <div className="label">Price:</div>
                <div className="value" xd-qa-type="label" xd-qa-name={record.mlsId+" - Price"}>{formatFlexMoney(record.listedPrice)}</div>
            </div>
            <div className="col">
                <div className="label">Date:</div>
                <div className="value">
                    Listed:{" "}
                    <span xd-qa-type="label" xd-qa-name={record.mlsId+" - Date Listed"}>{formatDate(record.dateListed)}</span>
                    <br/>
                    {record.dateSold && (<>
                        Sold: <span xd-qa-type="label" xd-qa-name={record.mlsId+" - Date Sold"}>{formatDate(record.dateSold)}</span>
                    </>)}
                </div>
            </div>
            <div className="col">
                <div className="label">Agent:</div>
                <div className="value" xd-qa-type="label" xd-qa-name={record.mlsId+" - Agent"}>{record.agentFirstName} {record.agentLastName}</div>
            </div>
        </div>
        <div className="action-btns">
            <button
                className="marketing-materials"
                onClick={() => onCreateMarketingMaterials(record)}
                xd-qa-type="button"
                xd-qa-name="Create Marketing Materials"
            >
                Create Marketing Materials
            </button>
        </div>
    </div>
);